import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap, ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
import { Countdown } from './Shared';
export const Pricing = () => {
  const checkoutUrl = 'https://profelisto.com.ar/checkouts/cn/hWNCfFZq9sh98XxdyzWkiJzm/es-ar?_r=AQABV1MujJr_3h_5U00zmHYiI8ArbR4wFo1tOvD9B34uL2Q';
  return <section id="precio" className="py-20 bg-brand-charcoal scroll-mt-10" data-id="element-99">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        {/* Header & Countdown */}
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-102">
            ⏰ PRECIO DE LANZAMIENTO
          </h2>
          <p className="text-lg text-brand-terracotta font-bold mb-8 uppercase tracking-wider" data-id="element-103">
            Oferta por tiempo limitado
          </p>
          <div className="mb-6" data-id="element-104">
            <Countdown data-id="element-105" />
          </div>
          <p className="text-red-300 font-medium text-sm" data-id="element-106">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* Pricing Card */}
        <div className="bg-white rounded-[28px] p-6 sm:p-10 shadow-2xl" data-id="element-107">
          <div className="text-center mb-8" data-id="element-108">
            <h3 className="text-3xl sm:text-4xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-109">
              Tu Pack Completo:
            </h3>
            <p className="text-gray-500 text-base sm:text-lg max-w-md mx-auto" data-id="element-110">
              Todo lo que necesitas para tu año de Pilates
            </p>
          </div>

          {/* Single Pack Option */}
          <div className="space-y-4 mb-8" data-id="element-111">
            <motion.div className="w-full text-left rounded-2xl border-2 border-brand-terracotta bg-brand-cream p-5 sm:p-6" data-id="element-112">
              <div className="flex items-center gap-4" data-id="element-113">
                {/* Radio */}
                <div className="flex-shrink-0" data-id="element-114">
                  <div className="w-6 h-6 rounded-full border-2 border-brand-terracotta flex items-center justify-center" data-id="element-115">
                    <div className="w-3 h-3 rounded-full bg-brand-terracotta" data-id="element-116" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 flex items-center gap-3 sm:gap-4 min-w-0" data-id="element-117">
                  <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-118">🏆</div>
                  <div className="flex-1 min-w-0" data-id="element-119">
                    <div className="font-bold text-brand-charcoal text-sm sm:text-base leading-tight mb-1" data-id="element-120">
                      PACK COMPLETO PILATES 360
                    </div>
                    <div className="flex flex-wrap gap-1.5 my-2" data-id="element-121">
                      <span className="inline-flex items-center gap-1 bg-brand-gold text-brand-charcoal text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-122">
                        ⭐ ACCESO TOTAL
                      </span>
                      <span className="inline-block bg-brand-terracotta/10 text-brand-terracotta text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-123">
                        AHORRAS $20.00 USD
                      </span>
                    </div>
                    <div className="text-xs sm:text-sm text-gray-500 leading-snug" data-id="element-124">
                      Pilates Mat + Pilates Reformer + 6 Bonus
                    </div>
                  </div>
                </div>

                {/* Price */}
                <div className="text-right flex-shrink-0" data-id="element-125">
                  <div className="text-xs sm:text-sm text-gray-400 line-through leading-none mb-1" data-id="element-126">
                    $39.90 USD
                  </div>
                  <div className="text-xl sm:text-3xl font-bold leading-none text-brand-terracotta" data-id="element-127">
                    $19.90 USD
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* CTA Button */}
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-base sm:text-lg font-bold py-5 px-6 rounded-2xl shadow-lg shadow-brand-terracotta/30 transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-3" data-id="element-128">
            SÍ, QUIERO EL PACK COMPLETO
            <ArrowRight size={20} data-id="element-129" />
          </a>

          <p className="text-center italic text-gray-500 text-sm mt-6 max-w-md mx-auto" data-id="element-130">
            La opción más elegida por profesores de Pilates de habla hispana
          </p>

          <p className="text-center text-gray-400 text-xs mt-4 max-w-md mx-auto" data-id="element-131">
            💱 El pago se procesará en la moneda de tu país
          </p>
        </div>

        {/* Trust Footer */}
        <div className="grid grid-cols-2 gap-y-4 gap-x-6 mt-10 max-w-md mx-auto text-white/80 text-sm" data-id="element-132">
          <span className="flex items-center gap-2" data-id="element-133">
            <Lock size={16} className="text-white/60" data-id="element-134" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-135">
            <Zap size={16} className="text-brand-gold" data-id="element-136" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-137">
            <ShieldCheck size={16} className="text-green-400" data-id="element-138" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-139">
            <CreditCard size={16} className="text-white/60" data-id="element-140" /> Tarjeta ·
            Transferencia
          </span>
        </div>
      </div>

      {/* Comparison on lighter background */}
      <div className="bg-brand-cream mt-20 pt-20 pb-4" data-id="element-141">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
          {/* Comparison Table */}
          <div data-id="element-143">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-144">
              ¿Cuánto cuesta NO tenerlo?
            </h3>
            <div className="bg-white rounded-2xl shadow-lg border border-brand-sand overflow-hidden" data-id="element-145">
              <div className="grid grid-cols-2 bg-brand-charcoal text-white p-6" data-id="element-146">
                <div className="font-bold text-lg text-center" data-id="element-147">
                  Sin PILATES 360
                </div>
                <div className="font-bold text-lg text-center text-brand-gold" data-id="element-148">
                  Con PILATES 360
                </div>
              </div>
              <div className="divide-y divide-brand-sand" data-id="element-149">
                {[['Horas planificando desde cero cada semana', '5 minutos. Todo listo.'], ['Sesiones improvisadas sin progresión real', '+150 sesiones graficadas por nivel'], ['Grupos sin sistema claro', 'Estructura clara para cada nivel'], ['Siempre los mismos ejercicios', '100 variaciones listas para usar'], ['Miedo a que un alumno se lesione', 'Checklist de seguridad incluido'], ['Terminar cada clase agotada mentalmente', 'Llegas con todo resuelto'], ['Sin poder justificar un aumento de precio', 'Sistema documentado y profesional']].map((row, i) => <div key={i} className="grid grid-cols-2 p-6 hover:bg-brand-cream transition-colors" data-id="element-150">
                    <div className="text-gray-600 pr-4" data-id="element-151">{row[0]}</div>
                    <div className="text-brand-charcoal font-semibold pl-4 border-l border-brand-sand flex items-center gap-3" data-id="element-152">
                      <Check className="text-green-500 flex-shrink-0" size={20} data-id="element-153" />{' '}
                      {row[1]}
                    </div>
                  </div>)}
              </div>
            </div>
            <p className="text-center text-xl font-serif font-bold text-brand-charcoal mt-8" data-id="element-154">
              El lunes puedes improvisar o entrar con todo resuelto. Tú decides.
            </p>
          </div>
        </div>
      </div>
    </section>;
};